<template>
    <div class="d-flex w-100">
      <div class="d-flex w-100">
        <div class="col-md-3">
          <inqueryQmaFilter :qma="qma" @search="search"></inqueryQmaFilter>
        </div>
        <div class="col-md-9">
          <inqueryQmaTable :qma="qma" ref="inqueryQmaTable"></inqueryQmaTable>
        </div>
      </div>
    </div>
  </template>

<script>
import ActionsForm from '@/shared/mixins/actionsForm'
import ExpenseMixin from '@/views/private/finance/expenses/travelexpensezpag/mixins/ExpenseMixin'
import Multiselect from 'vue-multiselect'
import inqueryQmaFilter from '@/views/private/qma/inqueryQma/components/inqueryQmaFilter/inqueryQmaFilter.vue'
import inqueryQmaTable from '../components/inqueryQmaTable/inqueryQmaTable.vue'
// import { loading } from '@/shared/utils/UIHelper'

export default {
  name: 'inqueryQmaPivs',
  components: {Multiselect, inqueryQmaFilter, inqueryQmaTable},
  mixins: [ ActionsForm, ExpenseMixin ],
  data () {
    return {
      qma: 0
    }
  },
  mounted () {
    // this.getAllCategories()
  },
  methods: {
    search (data) {
      this.$refs.inqueryQmaTable.formSearch = data
      this.$refs.inqueryQmaTable.search(data, this.qma)
    }
    // onClearSection () {
    //   this.forms.listagemInterna = null
    //   this.forms.descricao = null
    // }
  }
}

</script>

  <style scoped>
  .col-md-3{
  padding-right: 0;
  padding-left: 0;
  }
  </style>



// WEBPACK FOOTER //
// src/views/private/qma/inqueryQma/inqueryQmaLv/inqueryQmaLv.vue